export const DETAIL = {
  init: () => {
    $('#sec-detail-close').on('click', DETAIL.close);
    $('#map-buttons .item:not(.no-info):not(.group), #map-buttons .group:not(.no-info) .list-item, #sec-list .facilities .item').on('click', DETAIL.open);
  },
  open: function() {
    const id = $(this).data('id');
    $('#sec-detail').stop(true,false).fadeIn(200, 'swing').scrollTop(0)
      .find('.content').hide();

    $('#id-' + id).show();
  },
  close: function() {
    $('#sec-detail').stop(true,false).fadeOut(200, 'swing');
  }
};